// HoverCard.js
import React from 'react';
import './HoverCard.css';

const HoverCard = ({ title, imageUrl, linkTo }) => {
  return (
    <a href={linkTo} className="hover-card">
      <div className="hover-card-content">
        <img src={imageUrl} alt={title} className="hover-card-image" />
        <div className="hover-card-overlay">
          <h3 className="hover-card-title">{title}</h3>
        </div>
      </div>
    </a>
  );
};

export default HoverCard;
